import { Component, effect, ViewChild } from '@angular/core';
import { DataAccessService } from 'src/app/shared/services/data-access/data-access.service';
import { IPlannedPBMTasksMap } from 'src/app/shared/models/tasks-planned';
import { Subscription } from 'rxjs/internal/Subscription';
import { TaskInfoService } from 'src/app/shared/services/task-info/task-info.service';
import { ColumnFilter, Table } from 'primeng/table';
import { Popover } from 'primeng/popover';
import { DataRepositoryService } from 'src/app/shared/services/data-repository/data-repository.service';
import { ColumnName, TaskType, TBTabName } from 'src/app/shared/models/core';
import { TaskMovementService } from 'src/app/shared/services/operations/task-movement.service';
import { TaskbankColumnService } from '../column-service/taskbank-column.service';
import { Navigation } from 'src/app/shared/entity/navigation';
import { SelectedTBRowKPI, TabColumnFilter } from 'src/app/shared/entity/utility-interfaces';
import { TaskbankColumnFilterService } from '../column-service/taskbank-column-filter.service';
import { ColumnFilterKeys } from 'src/app/shared/entity/enums';
import { SortingService } from 'src/app/shared/services/operations/sorting.service';
import { SelectedPreferencesENUM } from 'src/app/shared/models/preference';
import { KeyValue } from '@angular/common';
import { OrderIdColorPipe } from 'src/app/shared/pipe/OrderIdColor/order-id-color.pipe';
import { FilterMetadata, FilterService } from 'primeng/api';
import { getEventsByTab, getServiceCodesByTab, IndicatorDef } from 'src/app/shared/entity/indicator.const';
import { TaskBankFilterStateService } from 'src/app/shared/services/task-bank-filter/task-bank-filter-state.service';
import {  TBTabName as TabName } from 'src/app/shared/entity/enums';

@Component({
    selector: 'app-planned-pbm',
    templateUrl: './planned-pbm.component.html',
    styleUrls: ['../../../../../shared/css/primeng-table.component.scss'],
    providers: [OrderIdColorPipe],
    standalone: false
})
export class PlannedPbmComponent {
  private _table?: Table;
  private _lastAppliedTable?: Table;

  @ViewChild('dataTable')
  set table(table: Table | undefined) {
    this._table = table;
    if (!this._table) return;
    this.preserveTableScrollOnRefresh();
    if (this._lastAppliedTable === this._table) return;
    this.applySavedFilters();
    this.applyTaskBankSelectionFilter();
    this._lastAppliedTable = this._table;
  }
  get table(): Table {
    return this._table!;
  }

  /**
   * PrimeNG virtual-scroll resets scroll to top on data refresh via Scroller.calculateAutoSize
   * and Table._filter -> resetScrollTop. Neutralize both to keep the user's scroll position.
   */
  private preserveTableScrollOnRefresh(): void {
    const table = this._table;
    if (table?.scroller) {
      table.scroller.autoSize = false;
    }
    if (table) {
      table.resetScrollTop = () => {};
    }
    this.observeScrollerResize();
  }
  
  /**
   * Sets up a ResizeObserver to monitor changes in the size of the table's scroller element. 
   */
  private observeScrollerResize(): void {
    this.resizeObserver?.disconnect();
    const scrollerEl = this._table?.scroller?.getElementRef()?.nativeElement;
    if (!scrollerEl) return;
    this.resizeObserver = new ResizeObserver(() => {
      this._table?.scroller?.onWindowResize();
    });
    this.resizeObserver.observe(scrollerEl);
  }

  @ViewChild('orderColumnFilter') orderColumnFilter!: ColumnFilter;
  @ViewChild('statusColumnFilter') statusColumnFilter!: ColumnFilter;
  @ViewChild('indicatorPanel') indicatorPanel: Popover;

  loginDisplay: boolean = false
  plannedPbmData: IPlannedPBMTasksMap[] = []
  visibleColumns:any[]=[]
  showTable: boolean = true;
  private currentPreferenceId: string = '';
  private readonly taskFilterField = 'task_filter_keys';
  private readonly taskFilterKeys = Array.from(
    new Set([
      ...getServiceCodesByTab(TabName.PlannedPBM).map((item) => item.key),
      ...getEventsByTab(TabName.PlannedPBM).map((item) => item.key),
    ])
  );
  event = true;
  taskBankSubscription: Subscription[] = [];
  isFullScreen: boolean = false;
  additionalData:any={};
  displayItemDialog =false;
  header:string='';
  taskType = TaskType;
  selectedFilters: TabColumnFilter = {
    pbmOrderType: '',
    taskStatus: ''
  };
  activeIndicators: IndicatorDef[] = [];
  selectedTaskFilterServiceCode: string | null = null;
  selectedTaskFilterEvent: string | null = null;
  private resizeObserver: ResizeObserver | null = null;

  columnFilterKeys = ColumnFilterKeys;
  statuses = [
    { name: 'Planned' },
    { name: 'Requested' },
    { name: 'Completed' },
  ];
  pbmOrderType = [
    { name: 'ADHOC CUSTOMER PICKUP', value: 'AP' },
    { name: 'ADHOC CUSTOMER Delivery', value: 'AD' },
    { name: 'Recurring CustomerPickup', value: 'RP' },
    { name: 'Recurring CustomerDelivery', value: 'RD' },
    { name: 'Internal Mail Pickup', value: 'IP' },
    { name: 'Internal Mail Delivery', value: 'ID' },
    { name: 'Internal Transport Handover', value: 'IH' },
    { name: 'Internal Transport Pickup', value: 'TP' },
    { name: 'Service Point Handover', value: 'SH' },
    { name: 'Service Point Pickup', value: 'SP' },
    { name: 'Service Point Handover And Pickup', value: 'HP' },
    { name: 'Local Task', value: 'LH' },
    { name: 'Empty Mail Box', value: 'EB' },
    { name: 'Depot Pickup', value: 'DP' },
    { name: 'Depot Delivery', value: 'DD' },
    { name: 'PO Box', value: 'PB' },
    { name: 'Filial Pickup', value: 'FP' },
    { name: 'Filial Delivery', value: 'FD' },
    { name: 'Lantbrevbarning', value: 'LB' },
    { name: 'Recurring Mail Pickup', value: 'MP' },
    { name: 'Recurring Mail Delivery', value: 'MD' }
  ]
  navigation = Navigation;

  //getter and setter 
  get isCustomSort(): boolean{
    return this.sortingService.isCustomSort?? false;
  }
  // getter for select all value
  get isSelectAll() {
    return this.taskMovementService.isSelectedAll;
  }

  get showSelectedTaskKPI(): KeyValue<keyof SelectedTBRowKPI, string| number>[]{
    return this.taskMovementService.selectedTaskKPI;
  }

  private _tbLegends: unknown[] | null = null;
  // Legends are static config; cache once so the [colorlegends] input keeps a
  // stable reference and doesn't re-render every change-detection cycle.
  get tbLegends(){
    this._tbLegends ??= [...this.taskInfoService.gettaskBankLegends];
    return this._tbLegends;
  }

  showIndicatorPanel(event: Event, row: any): void {
    this.activeIndicators = row.indicators ?? [];
    this.indicatorPanel.toggle(event);
  }

  taskBankFilterSignalEffect(): void {
    effect(() => {
      const taskFilterState = this.taskBankFilterStateService.taskBankFilterState();
      const isPlannedPbmTab = this.taskInfoService.selectedTabName?.toLowerCase() === TBTabName.PlannedPBM.toLowerCase();

      if (!isPlannedPbmTab) {
        this.selectedTaskFilterServiceCode = null;
        this.selectedTaskFilterEvent = null;
        this.applyTaskBankSelectionFilter();
        return;
      }

      this.selectedTaskFilterServiceCode = taskFilterState.serviceCodeKey;
      this.selectedTaskFilterEvent = taskFilterState.eventKey;
      this.applyTaskBankSelectionFilter();
    });
  }

  constructor(
    public taskInfoService: TaskInfoService
    , public dataAccessService: DataAccessService
    , public dataRepositoryService: DataRepositoryService
    , public taskMovementService: TaskMovementService
    , private readonly taskBankColumnService: TaskbankColumnService
    , private readonly taskbankColumnFilterService: TaskbankColumnFilterService
    , public readonly sortingService: SortingService
    , private readonly filterService: FilterService
    , private readonly taskBankFilterStateService: TaskBankFilterStateService
  ) {
      this.filterService.register('task-filter-any', (rowValue: string[] | undefined, filterValue: string[] | null) => {
        if (!filterValue?.length) return true;
        if (!Array.isArray(rowValue) || !rowValue.length) return false;
        return filterValue.some((key) => rowValue.includes(key));
      });
      this.sortedTaskSelectionEfect();
      this.selectedColumnEffect();
      this.splitDraggedObservable();
      this.taskBankFilterSignalEffect();
  }

  get favList() {
    return this.taskInfoService.selectedPlannedFavList?.id ?? 'default';
  }
  

  ngOnInit(): void {
    this.plannedPBMselectedSubs();
    this.polygonTaskSelectSubs();
    this.polygonTaskDeselectSubs();
    this.columnFiltersClearedSubs();
  }

  /**
   * Clears local filter state and the table's applied filters when the Clear Filters action is triggered for this tab
   */
  columnFiltersClearedSubs() {
    this.taskBankSubscription.push(
      this.taskbankColumnFilterService.filtersCleared$.subscribe((tabName) => {
        if (tabName !== TBTabName.PlannedPBM) return;
        this.clearColumnFilters();
      })
    );
  }

  /**
   * Clears persisted column filters while preserving PrimeNG menu filter state.
   */
  private clearColumnFilters(): void {
    this.selectedFilters = {};
    this.resetColumnFilter('task_state', 'in');
    this.resetColumnFilter('pbm_order_id', 'startsWith');
    this._table?._filter();
    this.taskMovementService.resetTaskMovement();
    this.applyTaskBankSelectionFilter();
  }

  /**
   * Restores the array-based metadata shape expected by PrimeNG menu filters.
   * @param field Table field bound to the column filter.
   * @param matchMode PrimeNG match mode used by the column filter.
   */
  private resetColumnFilter(field: string, matchMode: string): void {
    if (!this._table) return;
    const filters = this._table.filters ?? (this._table.filters = {});
    filters[field] = [{ value: null, matchMode, operator: 'and' }] as FilterMetadata[];
  }


    /**
   * Subscribes to the `isSplitDragged$` observable from `taskbankColumnFilterService`
   * to monitor whether a split drag action has occurred.
   *
   * When a split dragged, it hides the overlay
   * for both `orderColumnFilter` and `statusColumnFilter`
   * `overlayVisible` property to `false`.
   */
  splitDraggedObservable() {
      this.taskbankColumnFilterService.isSplitDragged$.subscribe(dragged => {
        if(dragged) {
          if(this.orderColumnFilter?.overlayVisible) this.orderColumnFilter.overlayVisible = false;
          if(this.statusColumnFilter?.overlayVisible) this.statusColumnFilter.overlayVisible = false;
        }
      })
  }


  ngAfterViewInit() {
    this.getColumnFilters();
  }

  /**
   * Method handles subscription for plannedPBM task collection - full list and delta version
   */
  plannedPBMselectedSubs(){
    this.taskBankSubscription.push(
      this.dataAccessService.isPlannedPBMselected$.subscribe((plannedPbmData) => {
        if (plannedPbmData) {
          //check if custom sort is applied on the table
          if (this.sortingService.isCustomSortApplied && this.dataRepositoryService.plannedPbmTbCollection.size) {
            if (plannedPbmData?.isDeltaUpdate) {
              this.setPlannedPbmData(this.sortingService.processCustomSortingWithDelta());
            }
            this.sortingService.isCustomSort = true;
          } else {
            this.setPlannedPbmData([...this.dataRepositoryService.plannedPbmTbCollection.values()]);
          }
          this.taskMovementService.allowedTaskMoveData = [...this.dataRepositoryService.plannedPbmTbCollection.values()].filter((f: any) => f.isMovementAllowed)
        }
      })
    );
  }


  /**
   * Method handles subscription for updateColumn event
   */
  selectedColumnEffect() {
      effect(() => {
        if(this.dataRepositoryService.tempSelectedUserColumnPreferences()) {
          const taskBankSelectedPreference = this.dataRepositoryService.tempSelectedUserColumnPreferences()?.[SelectedPreferencesENUM.TASKBANK];
          const newPreferenceId = taskBankSelectedPreference?.id ?? '';
          
          const preferenceChanged = this.currentPreferenceId !== newPreferenceId;
          this.currentPreferenceId = newPreferenceId;
          
          this.visibleColumns=this.taskBankColumnService.getVisibleColumns(ColumnName.PlannedPBM, taskBankSelectedPreference?.columnList??[])
          
          if (preferenceChanged) {
            this.resetTable();
          }
        }else {
          //set the default column list
          this.visibleColumns = this.taskBankColumnService.getVisibleColumns(ColumnName.PlannedPBM);
          if (this.currentPreferenceId !== '') {
            this.currentPreferenceId = '';
            this.resetTable();
          }
        }
      })
    }

  /*
   * Resets the table to apply new column configurations
   */
  resetTable() {
    this.showTable = false;
    setTimeout(() => {
      this.showTable = true;
      setTimeout(() => this.applyTaskBankSelectionFilter(), 0);
    }, 0);
  }

  /**
   * This subscription triggers from Map component when certains tasks are selected under drawn polygon
   * & it manages the task selection for task movement
   */
  polygonTaskSelectSubs(){
    this.taskBankSubscription.push(
      this.dataAccessService.polygonTaskSelection$.subscribe((selectedRows) => {
        if(this.taskInfoService.selectedTabName.toLowerCase()===TBTabName.PlannedPBM.toLowerCase()){
          if (selectedRows) {
            this.taskMovementService.taskSelectionFromMapPolygon(selectedRows);
            if (this.taskMovementService.isSelectedAll) {
              this.sortingService.resetingCustomSorting();
            }
            if (this.sortingService.isCustomSortApplied && this.dataRepositoryService.plannedPbmTbCollection.size) {
              this.sortingService.isCustomSort = true;
            }
            else {
              this.setPlannedPbmData([...this.dataRepositoryService.plannedPbmTbCollection.values()]);
            }
            this.taskMovementService.allowedTaskMoveData = [...this.dataRepositoryService.plannedPbmTbCollection.values()].filter((f: any) => f.isMovementAllowed)
          }
        }
      })
    );
  }

  /**
   * This subscription triggers from Map component when certains tasks are deselected on delete polygon
   * & it manages the task deselection for task movement list
   */
  polygonTaskDeselectSubs(){
    this.taskBankSubscription.push(
      this.dataAccessService.polygonTaskDeselection$.subscribe((deSelectRows) => {
        if(this.taskInfoService.selectedTabName.toLowerCase()===TBTabName.PlannedPBM.toLowerCase()){
          if (deSelectRows) {
            deSelectRows.forEach((deselectTask:any)=>{
              if(deselectTask.isMovementAllowed){
                this.taskMovementService.handleMovementForTaskDeselection(deselectTask);
                this.taskMovementService.onTaskUnselection(deselectTask.task_id);
              }
            })
            if (this.taskMovementService.isSelectedAll) {
              this.sortingService.resetingCustomSorting();
            }
            if (this.sortingService.isCustomSortApplied && this.dataRepositoryService.plannedPbmTbCollection.size) {
              this.sortingService.isCustomSort = true;
            }
            else {
              this.setPlannedPbmData([...this.dataRepositoryService.plannedPbmTbCollection.values()]);
            }
            this.taskMovementService.allowedTaskMoveData = [...this.dataRepositoryService.plannedPbmTbCollection.values()].filter((f: any) => f.isMovementAllowed)
          }
        }
      })
    );
  }

  /**
   * Method runs the effect on task selection
   */
  sortedTaskSelectionEfect(){
    effect(() => {
      if (
        this.sortingService.$sortedTasksForMovement().length
      ) {
        //assign the new sorted data to computed's table data collector
        this.setPlannedPbmData([...this.sortingService.$sortedTasksForMovement()])
      }
      else{
        this.setPlannedPbmData([...this.dataRepositoryService.plannedPbmTbCollection.values()]);
      }
    });
  } 

  private setPlannedPbmData(data: IPlannedPBMTasksMap[]): void {
    this.plannedPbmData = this.decorateTaskFilterKeys(data);
    this.applyTaskBankSelectionFilter();
  }

  private applyTaskBankSelectionFilter(): void {
    const selectedKeys = [
      this.selectedTaskFilterServiceCode,
      this.selectedTaskFilterEvent,
    ].filter((key): key is string => !!key);

    this._table?.filter(selectedKeys, this.taskFilterField, 'task-filter-any');
  }

  private decorateTaskFilterKeys(data: IPlannedPBMTasksMap[]): IPlannedPBMTasksMap[] {
    return data.map((row) => ({
      ...row,
      [this.taskFilterField]: this.taskFilterKeys.filter(
        (key) => Boolean((row as unknown as Record<string, unknown>)[key])
      ),
    }));
  }

  saveColumnWidth(event: any) {
    this.taskBankColumnService.saveColumnWidth(event, this.visibleColumns);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    if(this.taskBankSubscription && this.taskBankSubscription?.length) {
      this.taskBankSubscription.forEach(item=>item.unsubscribe());
    }
  }
  filterData($event:any) {
    this._table?.filterGlobal($event?.target?.value??'', 'contains')
  }

  /**
   * Method calls the service method for sorting the dataset
   */
  setSelectedTaskSorting(){
    if(!this.sortingService.isCustomSortApplied){
      this.sortingService.setSelectedTaskSorting()
    }
    else{
      this.sortingService.resetingCustomSorting();
    }
  }

  /**
   * Method is called after PrimeNG's built-in sorting is complete
   * @param event sorting parameters 
   */
  onColumnSort(event: any) {
    if(this.dataRepositoryService.plannedPbmTbCollection.size){
      this.sortingService.setFlagsOnSortingEvent(event);
    }
    if (this.taskMovementService.isSelectedAll) {
      this.taskMovementService.selectedOptionsForTaskMove = [...this.plannedPbmData];
    }
  }

  /**
   * Method triggered on select All event, sets the flag and proceeses the task movement 
   * for all tasks
   * @param event select all checkbox click event
   */
  onSelectAllToggle(event:any){
    if (event.checked) {
      this.sortingService.resetingCustomSorting();
    }
    this.taskMovementService.onSelectAllToggle(event);
  }

  /**
   * Single entry point for every table selection change. The one-way [selection]
   * binding keeps selectedOptionsForTaskMove as the previous selection until we
   * overwrite it, so diffing the new selection against it yields the added and
   * removed rows and the phantom anchor unselect on shift+click nets out.
   */
  onSelectionChange(selection: any[]) {
    const previousSelection = ((this.taskMovementService.selectedOptionsForTaskMove ?? []) as IPlannedPBMTasksMap[]).filter(Boolean);
    const previousSelectionIds = new Set(previousSelection.map((task) => task.task_id));
    const normalizedSelection = (selection ?? []).filter(Boolean) as IPlannedPBMTasksMap[];
    const currentSelectionIds = new Set(normalizedSelection.map((task) => task.task_id));
    const removedTasks = previousSelection.filter((task) => !currentSelectionIds.has(task.task_id));
    const addedTask = normalizedSelection.find(
      (task) => task?.isMovementAllowed && !previousSelectionIds.has(task.task_id)
    );

    this.taskMovementService.selectedOptionsForTaskMove = normalizedSelection;

    if (removedTasks.length) {
      removedTasks.forEach((task) => this.taskMovementService.onTaskUnselection(task.task_id));
      if (this.taskMovementService.isSelectedAll) {
        this.sortingService.resetingCustomSorting();
        this.taskMovementService.isSelectedAll = false;
      }
    }

    if (addedTask) {
      this.taskMovementService.onTaskSelection(addedTask);
      this.taskMovementService.selectedOptionsForTaskMove =
        this.taskMovementService.selectedOptionsForTaskMove.filter(Boolean);
      if (this.taskMovementService.isSelectedAll) {
        this.taskMovementService.selectedOptionsForTaskMove = [...this.dataRepositoryService.plannedPbmTbCollection.values()];
        this.sortingService.resetingCustomSorting();
      }
    }
  }

  /**
   * This method reads and saves filter applied on task state multi select dropdown
   * @param filterEvent read filter applied on dropdown
   * @param filterCallback callback function to update UI with filter event value
   * @param filterKey selected column
  */
  onColumnFilterChange(filterEvent: any, filterCallback: any, filterKey: keyof TabColumnFilter) {
    filterCallback(filterEvent);
    this.selectedFilters[filterKey] = filterEvent;
    //Resetting the task movement, if filterEvent is Null (clear event is triggered)
    if (filterEvent === null || (Array.isArray(filterEvent) && filterEvent.length === 0)) {
      this.taskMovementService.resetTaskMovement();
    }
    this.taskbankColumnFilterService.saveColumnFilter(TBTabName.PlannedPBM, filterKey, filterEvent);
  }

  /**
   * to read column filters applied and display filtered data on UI
   */
  getColumnFilters() {
    const tabFilters = this.dataRepositoryService.columnFilterRecord[TBTabName.PlannedPBM];
    if (tabFilters) {
      for (const key of Object.values(this.columnFilterKeys)) {
        if (tabFilters[key] !== undefined) {
          this.selectedFilters[key] = tabFilters[key];
        }
      }
      this.applySavedFilters();
    }
  }

  /**
   * Apply saved filters on UI manually.
   */
  applySavedFilters() {
    if (this._table) {
      const filters = this._table.filters ?? (this._table.filters = {});
      Object.entries(this.taskbankColumnFilterService.columnFilterMap).forEach(([filterKey, { columnKey, matchMode }]) => {
        const selectedValue = this.selectedFilters[filterKey as keyof TabColumnFilter];
        if (selectedValue !== undefined && selectedValue !== null) {
          filters[columnKey] = [
            { value: selectedValue, matchMode },
          ];
        }
      });
      this._table._filter();
      this.applyTaskBankSelectionFilter();
    }
  }

  openItemDialog(element: any, type: string): void {
    const hasItems = type === 'items' && element.item_count > 0;
    const hasGoods = type === 'goods' && element?.goods_count > 0;

    if (hasItems || hasGoods) {
      this.showItemList(element, type);
    }
  }

  showItemList(element: any, type: string) {
    this.header = type === 'goods' ? 'Goods' : 'Items';
    this.additionalData = {
      element: element,
      title: type === 'goods' ? 'Goods' : 'Items',
      type: type,
      tab: TBTabName.PlannedPBM
    };
    this.displayItemDialog = true;
  }
  /**
   *  Opens the PBM Task Lookup page for the specific order ID.
   * @param pbm_order_id 
   */
  PBMlookup(pbm_order_id:string){
    this.taskInfoService.lookupPBMOrder(pbm_order_id)
  }

  /**
   * Closes the dialog
   * 
   * @param $event - A boolean indicating whether to close the dialog (true) or not (false).
   */
  closeDialog($event: boolean) {
    this.taskInfoService.closeDialog($event);
  }

  /**\
   * updates the active tab by invoking activeTabSubscription.
   */
  refreshActiveTabData() {
    this.taskInfoService.activeTabSubscription();
  }

  /**
   * get the current dialog type from the updatePopup state in taskInfoService.
   * 
   * @returns The dialog type as a string, or an empty string if not set.
  */
  get DialogType() {
    return this.taskInfoService?.updatePopup?.dialogType ?? '';
  }
}
